export default __webpack_public_path__ + "static/media/b02_c copy.80b6a845.png";